import { fetchRaiCredentials } from '../service/RAIService';

/**
 * RAI credentials + project id for the Gizmo pages.
 *
 * These used to come from REACT_APP_RAI_AUTH, with a hardcoded fallback in this
 * file — which meant the password shipped inside the JS bundle and was readable
 * by anyone who loaded the app. Both are gone. The values now live only in the
 * backend environment (RAI_UI_USERNAME / RAI_UI_PASSWORD / RAI_UI_PROJECT_ID)
 * and are fetched over an authenticated API, on demand, the first time a page
 * actually needs to talk to RAI.
 *
 * There is deliberately no fallback: if the fetch fails, callers get null and
 * should surface the failure rather than silently trying a stale credential.
 */
let _raiAuth = null;

/**
 * @returns {Promise<{username: string, password: string, projectID: string}|null>}
 */
export const getRaiAuth = async () => {
  if (_raiAuth) return _raiAuth;

  const credentials = await fetchRaiCredentials();
  if (!credentials || !credentials.username) return null;

  _raiAuth = {
    username: credentials.username,
    password: credentials.password,
    projectID: credentials.projectID,
  };

  return _raiAuth;
};
